
/**
 * Reveal animation on viewport 
 * @module RevealAnimation
 *
 * @param {object} options
 * @property {number} offset between 0 and 1
 * @property {boolean} once
 *
 */

/* eslint-disable */
const RevealAnimation = (root, arr) => {
    const items = [];
    const offset = 0.25;
    var num = 0;

    for(let item of arr){
        root.querySelectorAll(...item.selector).forEach(el => {
            items.push(el); 
            el.style.animation = `${item.animation.duration || `.3`}s ${item.animation.ease || `ease`} 1 normal both paused ${item.animation.name}`;
            if(item.animation.duration){
                el.classList.add('delay');
                el.style.animationDelay = `${item.animation.delay}s`;
            } 
        });
    }
   
    const config = {
        threshold: [offset]
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio >= offset) {
              if(!entry.target.classList.contains('delay'))  entry.target.style.animationDelay = `${num/8}s`;
                entry.target.style.animationPlayState = 'running';
               /* entry.target.addEventListener('animationend', () => {
                    console.log(entry.target, num);
                    entry.intersectionRatio >= offset && num--;
                }, {once: true});*/
                setTimeout(() => {
                    entry.intersectionRatio >= offset && num--;
                }, 1200);
                observer.unobserve(entry.target);num++;
            } else{
               // entry.isIntersecting && num--;
            }

        });
    }, config);

    items.forEach(item => observer.observe(item)); 
};

export default RevealAnimation;
